module.exports = __webpack_public_path__ + "img/help-set-up-the-plant.69d856b4.webp";